// R1 follow-up copy, 25 Sep: these are the backend's released silent-broker
// defaults, word for word (EmailAutomation email_automation/followup.py,
// _get_default_followup_message with engaged=False). They are shown to the
// advisor in the wizard, but an untouched step is SAVED EMPTY so the backend
// chooses the copy at send time -- it also knows when a broker has replied and
// then uses its engaged copy, which a saved message would override.
export function buildDefaultFollowUpMessages() {
  return [
    `Hi [NAME],

Just following up here - is the space still available?`,
    `Hi [NAME],

Just checking in on the above. If it's no longer available, just let me know and I'll cross it off my list.`,
    `Hi [NAME],

Last note from me on this one - if it frees up or you have something similar, send it my way.`,
  ];
}

const normalizeFollowUpText = (text) => String(text || '')
  .replace(/\r\n?/g, '\n')
  .replace(/[ \t]+$/gm, '')
  .trim();

// The message to save for follow-up step `index`: empty when the box is
// untouched or still holds that step's default; otherwise exactly as typed.
export function savedFollowUpMessage(message, index) {
  const normalized = normalizeFollowUpText(message);
  if (!normalized) return '';
  const defaults = buildDefaultFollowUpMessages();
  if (normalized === normalizeFollowUpText(defaults[index])) return '';
  return message;
}

export function buildFollowUpConfig(followUps, followUpCount) {
  if (!(followUpCount > 0)) return { enabled: false };
  return {
    enabled: true,
    followUps: (followUps || []).slice(0, followUpCount).map((f, i) => ({
      waitTime: f.waitTime,
      waitUnit: f.waitUnit,
      message: savedFollowUpMessage(f.message, i),
    })),
  };
}
